module.exports = __webpack_public_path__ + "img/paginate.7ff73775.svg";